import { fmhNpiAPI, REFERENCE_API_URL } from 'api/APIBase';

/** Gets prescriber information for multiple npis */
export async function getBulkPrescriberInfo(npis: string[]) {
    const url = `${REFERENCE_API_URL}/prescribers/bulk_lookup`;
    return fmhNpiAPI({ url }).post(npis).json<{
        prescribers: { prescriber_npi: string; first_name: string; last_name: string }[];
        not_found: string[];
    }>();
}

export async function getSupplierFeatures(npi: string) {
    const url = `${REFERENCE_API_URL}/suppliers/${npi}/features`;
    return fmhNpiAPI({ url }).get().json<{ supplier_feature_id: string; description: string }[]>();
}
